<template>
  <div class="calendar-horizontal">
    <dpc-button-date-select
      v-if="datesWithContent.length"
      v-model:iso-date-selected="isoDateSelected"
      :iso-date-start="isoDateStart"
      :iso-date-end="isoDateEnd"
      :iso-dates-with-content="isoDatesWithContent"
    ></dpc-button-date-select>
    <dpc-scroller
      v-model:current-index="currentScrollerIndex"
      config-preset="teaser-default"
      @run="onScrollerChange"
    >
      <dpc-scroller-item
        v-for="(teaser, index) in teaserList"
        :key="`${teaser.meta.id}-${index}`"
      >
        <dpc-teaser-event-reduced :data="teaser" />
      </dpc-scroller-item>

      <template #controls>
        <div class="calendar-horizontal__button">
          <!-- to center this button we need the div wrappers... -->
          <slot name="button" />
        </div>
        <div class="calendar-horizontal__button-pusher"></div>
      </template>
    </dpc-scroller>
  </div>
</template>

<script setup>
import { computed, watch, ref, toRefs } from 'vue';
import { getDayjsByUnix, getDayjsByDate } from '@utils/date';

const props = defineProps({
  teaserList: {
    type: Array,
    required: true,
  },
});
const { teaserList } = toRefs(props);

const datesWithContent = computed(() => {
  if (!teaserList.value) return [];
  return teaserList.value.map(teaser => String(teaser.extension.date));
});

const isoDatesWithContent = computed(() =>
  datesWithContent.value.map(value =>
    getDayjsByUnix(value).format('YYYY-MM-DD')
  )
);

const isoDateStart = computed(() => String(isoDatesWithContent.value[0]));
const isoDateEnd = computed(() =>
  getDayjsByDate(
    String(isoDatesWithContent.value[isoDatesWithContent.value.length - 1])
  ).format('YYYY-MM-DD')
);

const isoDateSelected = ref(isoDateStart.value);
const currentScrollerIndex = ref(0);

watch(isoDateSelected, isoDateSelected => {
  const index = isoDatesWithContent.value.findIndex(value => {
    return value === isoDateSelected;
  });
  currentScrollerIndex.value = index;
});

const onScrollerChange = index => {
  if (index === -1) return;
  isoDateSelected.value = isoDatesWithContent.value[index];
};
</script>
